/**
 * Created by andrey on 10.08.18.
 */

let Game;
const GameBase = function (level, options) {
    cleverapps.EventEmitter.call(this);

    Game.currentGame = this;

    this.levelContent = level.content;
    this.level = level;
    this.options = options || {};

    const snapshot = this.loadFromSnapshot();
    let savedGame = snapshot || this.loadSave();
    if (savedGame && !snapshot && !this.isSaveValid(savedGame)) {
        savedGame = undefined;
    }
    this.savedGame = savedGame || this.getInitialInfo();

    this.score = new Score(this.savedGame.score);
    this.moves = this.savedGame.moves || 0;
    this.timer = new GameTimer(this);
    this.counter = new Counter();
    
    this.counter.registerStage(10000, cleverapps.tutorial.startNextStep.bind(cleverapps.tutorial), cleverapps.tutorial);
    this.counter.registerStage(10001, this.startTutorial.bind(this), this);

    this.afterStartActions = this.options.afterStartActions || [];

    this.rewards = {};

    if (this.level.isRegular() && cleverapps.exp.isAvailable() && !this.level.isBonus()) {
        this.rewards[GameBase.REWARD_EXP] = this.level.isHard() ? GameBase.HARD_LEVEL_EXP_PRIZE : GameBase.EXP_PRIZE;
    }

    if (this.level.isRegular() && !this.level.isBonus() && cleverapps.stickersBook && cleverapps.stickersBook.isAvailable() && !cleverapps.stickersBook.isCompleted()) {
        this.rewards[GameBase.REWARD_STICKERS] = cleverapps.stickersBook.getLevelReward();
    }

    this.setBasicReward();

    this.rewards[GameBase.REWARD_HARD] = 0;

    if (this.level.isDanger()) {
        this.rewards[GameBase.REWARD_HARD] = GameBase.DANGER_REWARD;
    }

    const lantern = typeof Lantern !== "undefined" && Lantern.Get();
    if (lantern && lantern.isActive(this.level)) {
        lantern.onStart();
    }

    if (this.savedGame.rewards) {
        this.rewards = cleverapps.override(this.rewards, this.savedGame.rewards);

        if (this.rewards.mission && !Array.isArray(this.rewards.mission)) {
            delete this.rewards.mission;
        }
    }

    if (this.levelWithTutorial()) {
        PseudoRandom.GET().seed(this.level.getHumanReadableNumber() - 1);
    } else {
        PseudoRandom.GET().randomSeed();
    }

    this.outcome = GameBase.OUTCOME_UNKNOWN;

    if (cleverapps.flyingAd && this.needAddFlyingAd()) {
        cleverapps.flyingAd.setGame();
    }

    this.counter.turnOff();

    this.boatswain = new Boatswain(level);

    this.counter.registerStage(-2, this.begin.bind(this));
    this.counter.registerStage(-1, cleverapps.availableMove.pause.bind(cleverapps.availableMove, "game"));
    this.counter.registerStage(1000, this.checkOutcome.bind(this));
    this.counter.registerStage(1001, () => {
        cleverapps.availableMove.resume("game");
    });

    if (typeof Prolongation !== "undefined") {
        this.prolongation = new Prolongation();
        this.prolongation.on("acceptOffer", this.onAcceptProlongationOffer.bind(this), this);
    }

    if (typeof ScoreBar !== "undefined" && ScoreBar.isAvailable() && !this.level.isBonus()) {
        this.scoreBar = new ScoreBar(this.savedGame.scoreBar);
    }

    if (typeof BonusLevelCounter !== "undefined" && this.level.isBonus()) {
        this.bonusLevelCounter = new BonusLevelCounter();
    }

    if (cleverapps.lives && cleverapps.lives.amount > cleverapps.lives.getMaxLives()) {
        this.moreThenMaxRegenLife = true;
    }

    this.takeLife(true);
};

GameBase.prototype = Object.create(cleverapps.EventEmitter.prototype);
GameBase.prototype.constructor = GameBase;

GameBase.prototype.checkOutcome = function () {
    if (this.outcome === GameBase.OUTCOME_UNKNOWN || cleverapps.focusManager.isFocused()) {
        return;
    }

    if (this.goalCounter && this.goalCounter.isActive()) {
        return;
    }

    this.trigger("haveOutcome", this.outcome);
};

GameBase.prototype.getMode = function () {
    return GameBase.MODE_REGULAR;
};

GameBase.prototype.shouldSkipVictoryWindow = function () {
    return this.level.content.skipVictoryWindow;
};

GameBase.prototype.needAddFlyingAd = function () {
    return true;
};

GameBase.prototype.levelWithTutorial = function () {
    if (cleverapps.config.editorMode) {
        return false;
    }

    if (cleverapps.isKnockoutGame()) {
        return false;
    }

    if (!this.levelContent.tutorial) {
        return false;
    }

    if (this.level.isBonusWorldLevel()) {
        return true;
    }

    if (!this.level.isRegular()) {
        return false;
    }

    if (cleverapps.user.isPlayingFakeLevels()) {
        return false;
    }

    return true;
};

GameBase.prototype.displayTutorial = function (f) {
    f();
};

GameBase.prototype.hasBegan = function () {
    if (this.hasDanger()) {
        return true;
    }
    if (["battlefield"].includes(cleverapps.config.type)) {
        return true;
    }
    if (cleverapps.config.type === "match3") {
        return this.beginMoves !== this.moves;
    }
    if (["tile3", "solitaire"].includes(cleverapps.config.type) && Boolean(this.move)) {
        return true;
    }

    return this.moves > 0 || this.getPercentOfCompletion() > 0;
};

GameBase.prototype.begin = function (force) {
    if (!this.began && (this.hasBegan() || force)) {
        this.began = true;

        if (this.level.isRegular() || this.level.isBonusWorldLevel()) {
            if (levels.user.isUniqueStart(this.level.episodeNo, this.level.levelNo, this.level.content.version)) {
                this._churnActivated();
            }
        }

        cleverapps.centerHint.finishCenterHint();
    }
};

GameBase.prototype.setBasicReward = function () {
    this.basicReward = 0;

    if (this.level.isBonus() || this.level.isBonusRound()) {
        return;
    }

    if (this.getMode() === GameBase.MODE_HIGHSCORE) {
        return;
    }

    if (this.level.isRegular() || this.level.isDailyCup() || this.level.isAdsLevel()
        || this.level.isBonusWorldLevel() || this.level.isWeeklyTournamentLevel() || cleverapps.config.editorMode) {
        const rewards = RewardsConfig.LevelBasicReward;

        this.basicReward = (rewards[this.level.getRewardTag()] || rewards.default).hard;
    }
};

GameBase.prototype.addBasicReward = function () {
    this.addHardReward(this.basicReward);
};

GameBase.prototype.showMessage = function (message, callback) {
    const delay = 200;
    const duration = 1400;

    cleverapps.timeouts.setTimeout(() => {
        this.trigger("showMessage", message);
    }, delay);

    cleverapps.timeouts.setTimeout(callback, delay + duration);
};

GameBase.prototype.showStartGameMessage = function (f) {
    if (this.level.isHard()) {
        this.showMessage("message.hardLevel", f);
    } else {
        f();
    }
};

GameBase.prototype._churnActivated = function () {
    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.UNIQUE_START, this.getLevelStatsParams());
};

GameBase.prototype.getLevelStatsParams = function () {
    return {
        hash: this.level.hash,
        levelVersion: this.level.version,
        mission: this.level.getMissionTag()
    };
};

GameBase.prototype.setTimeout = function (callback, timeout) {
    return cleverapps.timeouts.setTimeout(() => {
        if (this.stopped) {
            return;
        }

        callback();
    }, timeout);
};

GameBase.prototype.getInfo = function () {
    return {
        rewards: this.rewards,
        score: this.score.getPoints(),
        puzzle_key: this.levelContent.puzzle_key
    };
};

// A level may stamp a puzzle_key into its content; when the content changes the key changes,
// so a save produced for the old content is discarded instead of loaded. Opt-in: levels without
// a puzzle_key are always valid. Games with their own save shape may extend this.
GameBase.prototype.isSaveValid = function (save) {
    const key = this.levelContent.puzzle_key;
    return key === undefined || save.puzzle_key === key;
};

GameBase.prototype.getInitialInfo = function () {
    return {};
};

GameBase.prototype.loadFromSnapshot = function () {
    const data = cleverapps.loadedSnapshot && cleverapps.loadedSnapshot.games;
    if (data && data.episode === this.level.episodeNo && data.level === this.level.levelNo) {
        return data;
    }
};

GameBase.prototype.loadSave = function () {};

GameBase.prototype.getDailyCupStars = function () {
    return 1;
};

GameBase.prototype.initPool = function () {

};

GameBase.prototype.stop = function () {
    this.counter.turnOff();
    this.timer.stop();
    levels.FPS.stop();

    runCleaners(this);

    cleverapps.userStatus.destructor();
    cleverapps.menuBar.stopItems();
    cleverapps.exclamation.remove();

    if (cleverapps.flyingAd) {
        cleverapps.flyingAd.onGameStop();
    }

    this.stopped = true;
    this.trigger("stop");
    this.purge();
};

GameBase.prototype.bonusByLeftMoves = function (f) {
    this.animateBonus(f);
};

GameBase.prototype.needBonusByLeftMoves = function () {
    return false;
};

GameBase.prototype.animateBonus = function (f) {
    f();
};

GameBase.prototype.leave = function (f) {
    if (this.outcome !== GameBase.OUTCOME_UNKNOWN) {
        f();
        return;
    }

    if (this.stillNoPenalty()) {
        f();
        this.giveUp();
        return;
    }

    if (this.level.isBonus()) {
        f();
        this.win();
        return;
    }

    new ConfirmExitWindow({
        action: this.lose.bind(this)
    });
    cleverapps.focusManager.onceNoWindowsListener = f;
};

GameBase.prototype.takeLife = function (silent) {
    if (cleverapps.unlimitedLives && !cleverapps.unlimitedLives.checkBuyed()) {
        if (this.level.isDailyCup() && !cleverapps.dailyCup.withLives()) {
            return;
        }
        cleverapps.lives.take(silent);
    }
};

GameBase.prototype.giveLife = function () {
    if (cleverapps.unlimitedLives && !cleverapps.unlimitedLives.checkBuyed()) {
        if (this.level.isDailyCup() && !cleverapps.dailyCup.withLives()) {
            return;
        }

        if (this.moreThenMaxRegenLife || cleverapps.lives.amount < cleverapps.lives.getMaxLives()) {
            cleverapps.lives.give();
        }
    }
};

GameBase.prototype.setOutcome = function (outcome) {
    if (this.outcome !== GameBase.OUTCOME_UNKNOWN) {
        return;
    }
    this.outcome = outcome;

    cleverapps.user.incProgressCompare(outcome === GameBase.OUTCOME_VICTORY ? 30 : 1);

    if (cleverapps.config.debugMode) {
        console.log(`OUTCOME: ${outcome}`);
    }

    BeforeOutcomeAction.call(this);
    this.trigger("outcome", outcome);
    this.counter.trigger();
};

GameBase.prototype.win = function () {
    this.setOutcome(GameBase.OUTCOME_VICTORY);
};

GameBase.prototype.lose = function () {
    this.setOutcome(GameBase.OUTCOME_LOST);
};

GameBase.prototype.giveUp = function () {
    this.setOutcome(GameBase.OUTCOME_GAVEUP);
};

GameBase.prototype.incCounter = function (f) {
    if (!cleverapps.config.editorMode) {
        this.counter.turnOn();
    }
    this.counter.inc();
    f();
};

GameBase.prototype.decCounter = function (f) {
    this.counter.dec();
    cleverapps.userStatus.reportUserAction();
    f();
};

GameBase.prototype.gameplayStartIntroAction = function (f) {
    this.gameplayStart();
    f();
};

GameBase.prototype.gameplayStart = function () {
    connector.platform.gameplayStart(this.level.getHumanReadableNumber());
    addCleaner(this, () => connector.platform.gameplayStop(this.level.getHumanReadableNumber()));
};

GameBase.prototype.listIntroActions = function () {
    return [
        this.gameplayStartIntroAction.bind(this),
        this.incCounter.bind(this),
        this.startBoosters.bind(this),
        this.showDifficultyHint.bind(this),
        this.showScreen.bind(this),
        this.restoreProgressUpdate.bind(this),
        this.runBeforeStartActions.bind(this),
        this.showStartGameMessage.bind(this),
        this.decCounter.bind(this),
        this.startIntroTutorial.bind(this),
        this.startOldTutorial.bind(this),
        this.runAfterStartActions.bind(this)
    ];
};

GameBase.prototype.startIntroTutorial = function (f) {
    if (cleverapps.tutorial) {
        cleverapps.tutorial.startScenario();
    }
    f();
};

GameBase.prototype.startOldTutorial = function (f) {
    if (this.levelWithTutorial()) {
        this.displayTutorial(f);
    } else {
        f();
    }
};

GameBase.prototype.startTutorial = function () {
    if (!cleverapps.tutorial.isActive() && !cleverapps.focusManager.isFocused()) {
        cleverapps.tutorial.startScenario();
    }
};

GameBase.prototype.startBoosters = function (f) {
    for (const id in cleverapps.boosters.boosters) {
        cleverapps.boosters.boosters[id].onGameStarted();
    }
    f();
};

GameBase.prototype.showDifficultyHint = function (f) {
    if (this.needDifficultyHint()) {
        cleverapps.centerHint.createTextHint(Messages.get("StatisticsHint.Text", {
            percent: this.calcCompletePercent(this.level.getHumanReadableNumber()),
            level: cleverapps.user.getVirtualLevel()
        }), MinimalDialogue.POSITIONS.BOTTOM);
    }

    f();
};

GameBase.prototype.showScreen = function (f) {
    f();
};

GameBase.prototype.restoreProgressUpdate = function (f) {
    cleverapps.restoreProgress.update();
    f();
};

GameBase.prototype.runBeforeStartActions = function (f) {
    this.trigger("beforeStartActions");
    f();
};

GameBase.prototype.useLives = function () {
    return cleverapps.lives;
};

GameBase.EXP_PRIZE = 1;
GameBase.HARD_LEVEL_EXP_PRIZE = 3;

GameBase.DANGER_REWARD = 15;

GameBase.REWARD_EXP = "exp";
GameBase.REWARD_HARD = "hard";
GameBase.REWARD_BOOSTERS = "boosters";
GameBase.REWARD_SOFT = "soft";
GameBase.REWARD_STICKERS = "stickers";

GameBase.OUTCOME_UNKNOWN = undefined;
GameBase.OUTCOME_VICTORY = 1;
GameBase.OUTCOME_LOST = 2;
GameBase.OUTCOME_GAVEUP = 3;

GameBase.MODE_REGULAR = "regular";
GameBase.MODE_HIGHSCORE = "highscore";

GameBase.prototype.stillNoPenalty = function () {
    if (cleverapps.isRumble()) {
        return false;
    }

    if (this.outcome !== GameBase.OUTCOME_UNKNOWN) {
        return false;
    }

    if (this.bonusTimer) {
        return false;
    }

    return !this.hasBegan();
};

GameBase.prototype.addHardReward = function (amount, silent) {
    this.rewards[GameBase.REWARD_HARD] = (this.rewards[GameBase.REWARD_HARD] || 0) + amount;
    if (!silent) {
        this.trigger("rewardHard", amount);
    }
};

GameBase.prototype.addMissionReward = function (missionType, amount) {
    if (!this.rewards.mission) {
        this.rewards.mission = [];
    }

    let reward = this.rewards.mission.find((reward) => reward.missionType === missionType);
    if (!reward) {
        reward = { missionType, amount: 0 };
        this.rewards.mission.push(reward);
    }
    reward.amount += amount;
};

GameBase.prototype.getMissionRewardAmount = function (missionType) {
    if (!this.rewards.mission) {
        return 0;
    }

    const reward = this.rewards.mission.find((reward) => reward.missionType === missionType);
    return reward ? reward.amount : 0;
};

GameBase.prototype.addSoftReward = function (amount, options) {
    this.rewards[GameBase.REWARD_SOFT] = (this.rewards[GameBase.REWARD_SOFT] || 0) + amount;

    this.trigger("rewardSoft", amount, options);
};

GameBase.prototype.logCurrencyReward = function () {
    if (this.basicReward > 0) {
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.EARN.LEVEL_BASE_REWARD}_${GameBase.REWARD_HARD}`, { value: this.basicReward });
    }

    const extraReward = this.rewards[GameBase.REWARD_HARD] - this.basicReward;
    if (extraReward > 0) {
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.EARN.LEVEL_EXTRA_REWARD}_${GameBase.REWARD_HARD}`, { value: extraReward });
    }
};

GameBase.prototype.runAfterStartActions = function (cb, silent) {
    let actions = [
        function (f) {
            if (this.level.isRegular()) {
                levels.FPS.run(this.level.episodeNo, this.level.levelNo);
            }
            f();
        }.bind(this)
    ];

    if (!silent) {
        actions = actions.concat(this.afterStartActions);
    }

    cleverapps.focusManager.compound(cb, actions);
};

GameBase.prototype.getPercentOfCompletion = function () {
    return 0;
};

GameBase.prototype.onAcceptProlongationOffer = function (offer) {
    if (offer.reward === Prolongation.REWARDS.MOVES) {
        this.setMoves(offer.moves);
    }
};

GameBase.prototype.getProlongationMoves = function () {
    return 5;
};

GameBase.prototype.getNormalizedLevelReward = function (rewardConfig, benchmark) {
    const levelTag = this.level.getRewardTag();
    let rewardsAmount = rewardConfig[levelTag] || rewardConfig.default;
    const avgLevelFinished = GameBase.AVG_LEVELS_FINISHED[cleverapps.config.type];

    if (!avgLevelFinished) {
        return rewardsAmount;
    }

    let multiplier = GameBase.AVG_LEVELS_FINISHED[benchmark] / avgLevelFinished;
    multiplier = Math.min(multiplier, 3);
    rewardsAmount *= multiplier;

    const integerPart = Math.floor(rewardsAmount);
    const fractionalPart = rewardsAmount - integerPart;
    const randomChance = Math.random();
    const finalReward = (fractionalPart > randomChance) ? integerPart + 1 : integerPart;
    return finalReward;
};

GameBase.prototype.hasDanger = function () {
    return this.level.isDanger();
};

GameBase.prototype.needBonusReward = function () {
    return this.bonusLevelCounter;
};

GameBase.prototype.runScoreBarReward = function () {
    if (this.outcome === GameBase.OUTCOME_UNKNOWN && this.scoreBar.isStageCompleted()) {
        this.scoreBar.nextStage();
    }
};

GameBase.prototype.calcScoreBarGoal = function (stage) {
    return 100 + stage * 100;
};

GameBase.prototype.needDifficultyHint = function () {
    if (cleverapps.tutorial.getAvailableScenario() || this.levelWithTutorial()) {
        return false;
    }

    if (!this.level.isRegular() && !this.level.isHard()) {
        return false;
    }

    if (cleverapps.config.type === "board" && !this.emptySave) {
        return false;
    }

    if (Game.currentGame.getMode() === GameBase.MODE_HIGHSCORE) {
        return false;
    }

    if (!cleverapps.user.checkAvailable(cleverapps.config.availables.STATISTICS_MINIMAL)) {
        return false;
    }

    return this.level.isHard() || Math.random() < 0.25;
};

GameBase.prototype.calcCompletePercent = function (level) {
    const pseudo = PseudoRandom.GET("secondary");
    pseudo.seed(level);

    const percent = 100 * Math.exp(-0.0005 * level) * ((0.1 * Math.cos(0.075 * level) + 0.85)) + pseudo.random(0, 5);
    return Math.round(percent * 10) / 10;
};

GameBase.AVG_LEVELS_FINISHED = {
    board: 5.08,
    match3: 4.95,
    solitaire: 7.32,
    tile3: 3.35,
    blocks: 4.95,
    differences: 8.47
};

GameBase.QUICK_LOSE_TIMEOUT = cleverapps.parseInterval("30 seconds");